/* Cart submission for the welcome offer. Prices must be enforced by Shopify discounts. */
(function(root){
  'use strict';
  var CODE_PATTERN=/^TNL99-[SK](?:10|[1-9])-R6V8$/i;
  var REFILL_SET_VARIANTS=[58746360725829,58746360758597,58746360791365];
  function buildItems(selection, group){
    if(!selection.designs.length || selection.designs.length !== (selection.single?1:3)) throw new Error('Vælg alle designs i din pakke.');
    if(selection.extras.length>10)throw new Error('Du kan vælge op til 10 ekstra designs pr. ordre.');
    var items=[];
    function add(id,role,name){
      if(!Number.isSafeInteger(Number(id))||Number(id)<=0)throw new Error('Et design er ikke tilgængeligt. Vælg det igen.');
      var properties={_tnl_group:group,_tnl_offer:selection.single?'welcome-single':'welcome-kit',_tnl_role:role};
      if(name)properties.Design=name;
      items.push({id:Number(id),quantity:1,properties:properties});
    }
    if(!selection.single){
      add(selection.starterId,'starter');
      items[0].properties['Valgte designs']=selection.designs.map(function(d){return d.name;}).join(', ');
      items[0].properties['Til næste ordre']='50 kr. gavekort · gyldigt i 45 dage';
    }
    selection.designs.forEach(function(d){add(d.id,selection.single?'design':'included',d.name);});
    selection.extras.forEach(function(d){add(d.id,'extra',d.name);});
    selection.accessories.forEach(function(d){add(d.id,selection.single?'accessory':'gift');});
    return items;
  }
  function offerState(cart){
    var extras=0,kit=false;
    (cart.items||[]).forEach(function(it){
      var p=it.properties||{};
      if(p._tnl_group&&p._tnl_role==='extra')extras+=it.quantity;
      if(p._extra_refill==='99 kr.')extras+=it.quantity;
      if(p._tnl_role==='starter'||REFILL_SET_VARIANTS.indexOf(it.variant_id)>=0)kit=true;
    });
    if(extras>10)throw new Error('Du kan have op til 10 ekstra designs til 99 kr. i kurven.');
    return {extras:extras,code:extras?'TNL99-'+(kit?'K':'S')+extras+'-R6V8':''};
  }
  async function reconcile(cart,transport){
    var state=offerState(cart),codes=(cart.discount_codes||[]).map(function(d){return d.code;});
    var hasWelcome=(cart.items||[]).some(function(it){return it.properties&&it.properties._tnl_group;});
    var next=codes.filter(function(code){return !CODE_PATTERN.test(code)&&!(hasWelcome&&/^TNL99BASIC-8Q4M6V$/i.test(code));});
    if(state.code)next.push(state.code);
    if(codes.join(',')!==next.join(','))cart=await transport('cart/update.js',{discount:next.join(',')});
    if(state.code && !(cart.discount_codes||[]).some(function(d){return d.code.toUpperCase()===state.code && d.applicable;})){
      throw new Error('Rabatten på ekstra designs kunne ikke bekræftes. Luk kurven og prøv igen.');
    }
    return cart;
  }
  async function submit(selection, transport, group){
    var items=buildItems(selection,group);
    var before=await transport('cart.js');
    if(offerState(before).extras+selection.extras.length>10)throw new Error('Du kan have op til 10 ekstra designs til 99 kr. i kurven.');
    var attempted=false;
    var originalCodes=(before.discount_codes||[]).map(function(d){return d.code;});
    // Retire the old order-wide upsell coupon before measuring this offer's increase.
    if(originalCodes.some(function(code){return /^TNL99BASIC-8Q4M6V$/i.test(code);})){
      before=await transport('cart/update.js',{discount:originalCodes.filter(function(code){return !/^TNL99BASIC-8Q4M6V$/i.test(code);}).join(',')});
    }
    try{
      attempted=true;
      await transport('cart/add.js',{items:items});
      var cart=await reconcile(await transport('cart.js'),transport);
      var lines=cart.items.filter(function(it){return it.properties&&it.properties._tnl_group===group;});
      var count=lines.reduce(function(n,it){return n+it.quantity;},0);
      // Native discounts can allocate across matching designs from several groups.
      // Verify the whole-cart increase, allowing an existing discount to lower it.
      if(count!==items.length || !Number.isFinite(cart.total_price) || cart.total_price>before.total_price+selection.expectedTotal){
        throw new Error('Pakkens rabat kunne ikke bekræftes. Intet fra denne pakke er tilføjet. Prøv igen senere.');
      }
      return cart;
    }catch(error){
      if(attempted){
        try{
          var current=await transport('cart.js'),updates={};
          current.items.forEach(function(it){if(it.properties&&it.properties._tnl_group===group)updates[it.key]=0;});
          if(Object.keys(updates).length)await transport('cart/update.js',{updates:updates,discount:originalCodes.join(',')});
        }catch(cleanupError){throw new Error('Kurven kunne ikke kontrolleres. Kontrollér varerne i kurven, før du prøver igen.');}
      }
      throw error;
    }
  }
  root.TNLWelcomeCart={buildItems:buildItems,submit:submit,reconcile:reconcile,offerState:offerState};
  if(typeof module!=='undefined')module.exports=root.TNLWelcomeCart;
})(typeof window!=='undefined'?window:globalThis);
